<template>
  <div class="container-fluid">
    <div class="col-12">
      <div class="row mt-5">
        <!-- Container Construct-->
        <div class="col-3">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Fotos</strong>
              <br>
              letzte Aktivität
            </div>
            <p class="text-center pt-2">
              <strong>10 neue Fotos</strong></p>
            <!-- SLIDER-->
            <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">

                <div class="carousel-item p-4" v-for="(photo, index) in PhotosDashboard" :class="{ 'active': index === 0 }">
                  <img class="d-block w-100" :src="photo.src" :id="photo.id"
                       alt="Second slide">
                  <p class="text-center filename">{{ photo.orig_filename }}</p>
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls" role="button"
                 data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls" role="button"
                 data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
            <!-- SLIDER END-->
          </div>
        </div>
        <div class="col-3">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Berichte</strong>
              <br>
              letzte Aktivität
            </div>
            <p class="text-center pt-2"><strong>4 neue
              Berichte</strong></p>
            <!-- SLIDER-->
            <div id="carouselExampleControls2" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="First slide">
                  <p class="text-center" style="color:#0F4C81;">Dateiname</p>
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="Second slide">
                  <p class="text-center" style="color:#0F4C81;">Dateiname</p>
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="Third slide">
                  <p class="text-center" style="color:#0F4C81;">Dateiname</p>
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls2" role="button"
                 data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls2" role="button"
                 data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

            <!-- SLIDER END-->
          </div>
        </div>
        <div class="col-3">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Pläne</strong>
              <br>
              letzte Aktivität
            </div>
            <p class="text-center pt-2">
              <strong>6 neue Pläne</strong>
            </p>
            <!-- SLIDER-->
            <div id="carouselExampleControls3" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="First slide">
                  <p class="text-center filename">Dateiname</p>
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="Second slide">
                  <p class="text-center filename">Dateiname</p>
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="https://via.placeholder.com/300x120"
                       alt="Third slide">
                  <p class="text-center filename">Dateiname</p>
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls3" role="button"
                 data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls3" role="button"
                 data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

            <!-- SLIDER END-->
          </div>
        </div>
        <div class="col-3">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Übersicht</strong>
              <br>
              Insgesamt
            </div>
            <div class="col-12 pl-5 pt-2">
              <ul class="uebersicht">
                <li><strong>7 Benutzer</strong></li>
                <li><strong>415 Fotos</strong></li>
                <li><strong>6 Pläne</strong></li>
                <li><strong>4 Berichte</strong></li>
              </ul>
            </div>
          </div>

        </div>
      </div>

      <div class="row mt-4">

        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#" @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-file-image-o" aria-hidden="true"></i>
            </div>

            <p class="text-center pt-2">
              <strong>FOTOS HOCHLADEN</strong></p>
            </a>
          </div>

        </div>

        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#" @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </div>
            <p class="text-center pt-2">
              <strong>FOTOS BEARBEITEN</strong></p>
            </a>
          </div>

        </div>
        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#" @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-file-text" aria-hidden="true"></i>

            </div>
            <p class="text-center pt-2">
              <strong>BAUSTELLENBERICHT ERSTELLEN</strong>
            </p>
            </a>
          </div>

        </div>
        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#" @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-pencil" aria-hidden="true"></i>
            </div>
            <p class="text-center pt-2">
              <strong>BAUSTELLENBERICHT <br> ANZEIGEN /
              <br> BEARBEITEN</strong></p>
            </a>
          </div>

        </div>

        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#" @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-book" aria-hidden="true"></i>
            </div>
            <p class="text-center pt-2">
              <strong>BAUTAGEBUCH FÜHREN</strong></p>
            </a>
          </div>

        </div>
        <div class="col-2">
          <div class="col-12 action_tiles">
            <a href="#"  @click="message">
            <div class="col-12 text-center action_tiles_container">
              <i class="fa fa-plus-square" aria-hidden="true"></i>
            </div>
            <p class="text-center pt-2"><strong>PLÄNE HOCHLADEN</strong></p>
            </a>
          </div>

        </div>
      </div>
      <div class="row mt-4">

        <div class="col-4">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Statistik</strong>
              <br>
              letzte Aktivität
            </div>
            <canvas id="myChart" width="300" height="300"></canvas>
          </div>

        </div>

        <div class="col-4">
          <div class="col-12 p-0">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>Wetter</strong>
              <br>
              letzte Aktivität
            </div>
            <a class="weatherwidget-io" href="https://forecast7.com/de/51d426d88/mulheim/"
               data-label_1="MÜLHEIM AN DER RUHR" data-label_2="WETTER" data-theme="original">MÜLHEIM AN
              DER RUHR WETTER</a>
          </div>

        </div>

        <div class="col-4">
          <div class="col-12 p-0 tile">
            <div class="col-12 pt-2 pb-2 tileHeader">
              <strong>API</strong>
              <br>
              API Aktivität
            </div>
            <div class="currency">
              <p style="padding: .5em 1em;" v-for="currency in info">International Code: <strong>{{currency.code}}</strong> und Kurs <strong>{{currency.rate}}</strong></p>
            </div>
          </div>

        </div>
      </div>

    </div>

<!-- Modal View -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog col-2" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Baustellenbericht erstellen</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="recipient-name" class="col-form-label">Berichtname:</label>
                <input type="text" class="form-control" id="recipient-name">
              </div>
              <div class="form-group">
                <label for="message-text" class="col-form-label">Nachricht:</label>
                <textarea class="form-control" id="message-text"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Send message</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal View END-->

  </div>

</template>
<script>
/** Import Libary Chart JS **/
import Chart from 'chart.js'
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import Main from '../photo/components/Main'
import moment from 'moment'
export default {
  methods: {
    message () {
      /** Java Function **/
      $('#exampleModal').modal('show')
    },
    loadWeather () {
      /** Wetter JS **/
      !(function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0]
        if (!d.getElementById(id)) {
          js = d.createElement(s)
          js.id = id
          js.src = 'https://weatherwidget.io/js/widget.min.js'
          fjs.parentNode.insertBefore(js, fjs)
        }
      }(document, 'script', 'weatherwidget-io-js'))
    },
    getUserName (id) {
      this.creators.forEach(function (value, i) {
        if (value.user_id == id.user_id) {
          id.userName = value.firstname + ' ' + value.lastname
        }
      })
      return id.userName
    },
    loadChart () {
      new Chart(document.getElementById('myChart'), {
        type: 'bar',
        data: {
          labels: ['1900', '1950', '1999', '2050'],
          datasets: [{
            label: 'Europe',
            type: 'line',
            borderColor: '#8e5ea2',
            data: [408, 547, 675, 734],
            fill: false
          }, {
            label: 'Africa',
            type: 'line',
            borderColor: '#3e95cd',
            data: [133, 221, 783, 2478],
            fill: false
          }, {
            label: 'Europe',
            type: 'bar',
            backgroundColor: 'rgba(0,0,0,0.2)',
            data: [408, 547, 675, 734]
          }, {
            label: 'Africa',
            type: 'bar',
            backgroundColor: 'rgba(0,0,0,0.2)',
            backgroundColorHover: '#3e95cd',
            data: [133, 221, 783, 2478]
          }
          ]
        },
        options: {
          title: {
            display: true,
            text: 'Population growth (millions): Europe & Africa'
          },
          legend: {display: false}
        }
      })
    },
    async getfileImage (photo) {
      await fetch(
        process.env.VUE_APP_BASE_URL + 'getfile/photo/' + photo.id + '/250x250/4:3',
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string'
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            photo.src = reader.result
          }
          this.PhotosDashboard.push(photo)
          return this.PhotosDashboard
        })
    },
    async getImages () {
    //  $(".spinner-cover").show();
      let _this = this

      let params = {
        'filterparams': {
          'searchstring': '',
          'date_from': '',
          'date_to': '',
          'tags': '',
          'plan_ids': [],
          'selection_ids': [],
          'creator_ids': [],
          'hasplans': '',
          'hastags': '',
          'hasdescription': ''
        },

        'order': {
          'photodate': 'DESC'
        },
        'start': 0,
        'perpage': 10
      }

      await axios.post(this.getImagesUrl, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: 'string',
          accept: 'application/json'
        }
      })
        .then(response => {
          if (response.status === 200) {
            this.DashboardPhotos = response.data.data.photos
          }
          _this.PhotosDashboard = []
          this.meta = response.data.data.meta
          this.$store.state.photo.filtered = this.meta.filtered
          this.$store.state.photo.total = this.meta.total
          this.$store.state.photo.length = response.data.data.photos.length
          if (!response.data.data.photos) {
            this.$store.state.photo.LStart = 0
            this.$store.state.photo.LEnd = 0
          }
          this.$store.state.photo.LStart = (this.meta.page * this.meta.perpage) + 1
          this.$store.state.photo.LEnd = +(this.meta.page * this.meta.perpage) + 10
          this.$store.state.photo.TPage = Math.ceil(this.meta.filtered / this.meta.perpage)
          if (!parseInt(this.meta.filtered)) { this.$store.state.photo.TPage = 1 }
          this.$store.state.photo.page = parseInt(this.meta.page) + 1
          if (response.data.data.photos) {
            response.data.data.photos.forEach(function (value, i) {
              let ii = value
              let date = value.photodate
              ii.photodate = moment(String(date)).format('DD.MM.YYYY')
              ii.photodateBymonth = moment(String(date)).format('MMM DD')
              ii.photodateBytime = moment(String(date)).format('hh:mm')
              ii.photodateBydot = moment(String(date)).format('DD.MM.YYYY')
              // ii.userName=this.getUserName(ii);
              ii.src = require('@/assets/images/dumy.jpg')
              // _this.PhotosDashboard = [];
              _this.getfileImage(ii)
            })
          } else {
            _this.PhotosDashboard = []
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.$root.$emit('afterImageLoad', _this.PhotosDashboard)
          this.$store.commit('setAllImages', _this.PhotosDashboard)
          $('.spinner-cover').hide()
        })
    },
    loadAPI () {
      axios
        .get('https://api.coindesk.com/v1/bpi/currentprice.json')
        .then(response => {
          this.info = response.data.bpi
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => this.loading = false)
    }
  },
  created () {
    this.loadAPI()
    this.getImages('PDDashboard')
  },
  mounted () {
    this.loadChart()
    this.loadWeather()
  },
  name: 'PdDashboard',
  data () {
    return {
      info: '',
      getImagesUrl: process.env.VUE_APP_BASE_URL +
        '/project/' +
        this.$route.params.id +
        '/photos/getlist',
      PhotosDashboard: []
    }
  }
}
</script>

<style scoped>

div.container-fluid{
  color:#0F4C81;
}
p.filename {
  color:#0F4C81;
}

div.tile{
  background-color: lightgray;
  min-height: 320px;
}
div.tileHeader{
  color:white;
  background-color:#0F4C81;
}
div.tile p strong{
  color:#0F4C81;
  font-size: 18px;
}
div.action_tiles{
  min-height:250px;
  background-color: lightgray;
}

div.action_tiles_container{
  padding-top:4em;
}
div.action_tiles_container i{
  font-size:4em;
  color:#0F4C81;
}
strong {
  font-size: 16px;
}

ul.uebersicht li {
  list-style: square;
  color: #0F4C81;
  font-size: 20px;
  padding-bottom: .5em;
}

ul.uebersicht strong {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/PdDashboard.vue